/*
 * Copyright 1999-2024 Jagex Ltd.
 */
import styled from '@emotion/styled';
import { Container as BaseContainer, BoxProps } from 'theme-ui';
import DualBackground from '@static/dual.jpg';

export const MainContainer = styled(BaseContainer)<BoxProps>`
  height: 100%;
  background-image: url(${DualBackground});
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
`;
